import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ModalHeader } from 'reactstrap';
import { Icon, TsrSvgIcon } from 'tacho-ui';
import styles from './styles.module.scss';

interface TachoModalHeaderProps {
    title: string | JSX.Element;
    icon?: Icon;
    titleHorizontalLine?: boolean;
    isReadOnly?: boolean;
    isPending?: boolean;
    className?: string;
    onToggle: () => void;
}
export const TachoModalHeader: React.FC<TachoModalHeaderProps> = ({
    title,
    isPending,
    isReadOnly,
    titleHorizontalLine,
    className,
    icon,
    onToggle,
}) => {
    const TitleIcon = icon;
    return (
        <ModalHeader
            toggle={() => !isPending && onToggle && onToggle()}
            className={`${className || ''} ${styles.modalTitle} ${titleHorizontalLine ? styles.noNavTitle : ''}`}
        >
            {TitleIcon && <TsrSvgIcon icon={TitleIcon} titleIcon className="titleIcon" />} {title}
            {isReadOnly && (
                <>
                    <FormattedMessage id="tachoModalReadonly" />
                </>
            )}
        </ModalHeader>
    );
};
